// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4082":"9732c34a","5217":"9cc1f262","5238":"8c37bf3f"}[chunkId] + ".chunk.css";
};